import React from 'react'
import ArrowRightUpLineSVG from "../../assets/icons/arrow-right-up-line-dark.svg";

const ArrowRightUpLineDark = ({ className = '' }) => {
  return (
    <img
      src={ArrowRightUpLineSVG}
      alt="Arrow Right Up"
      className={`${className}`}
    />
  );
};

export default ArrowRightUpLineDark;
